function encryptPassword(password) {
      const base64 = window.btoa(encodeURIComponent(password).replace(/%([0-9A-F]{2})/g, 
        (match, p1) => String.fromCharCode(parseInt(p1, 16)))
      );
      return base64;
  }

export default encryptPassword;

